export default {
  label: 'Chat mit unserem Team',
  label_unread: 'Chat mit unserem Team, {{count}} neu',
};
